import React from "react";
import { Route, Routes } from "react-router-dom";
import WelcomePage from "../Components/WelcomePage";
import GetReady from "../Components/GetReady";
import VerifyAddress from "../Components/VerifyAddress";
import VerifyIdentity from "../Components/VerifyIdentity";
// import UploadDocument from "../Components/UploadDocument";


const Dashboard = () => {
    return (
        <div>
            <Routes>
                <Route index element={<WelcomePage />} />
                <Route path="getready" element={<GetReady />} />
                <Route path="verifyidentity" element={<VerifyAddress />} />
                {/* <Route path="verifyidentity" element={<VerifyIdentity />} /> */}
                <Route path="uploadDocument" element={<VerifyIdentity />} />
            </Routes>
        </div>
    )
}

export default Dashboard